import React from "react";
import ListJobTitle from "../../../containers/Settings/JobTitle/index";
const SettingJobTitle = () => {
  return <ListJobTitle />;
};
export default SettingJobTitle;
